import { useEffect, useRef, useState } from 'react'
import styles from './HeroBannerTile.module.scss'

/** Survives remounts when the carousel re-keys slides after a step. */
const loadedSrcs = new Set()

/**
 * Image-only Hero tile (3:4) for BO site preview.
 * Native link/image drag is disabled so carousel swipe stays reliable.
 */
export default function HeroBannerTile({ banner }) {
  const href = (banner.href || banner.ctaHref || '').trim()
  const alt = banner.imageAlt || ''
  const src = banner.imageSrc || ''
  const imgRef = useRef(null)
  const [ready, setReady] = useState(() => Boolean(src && loadedSrcs.has(src)))

  useEffect(() => {
    if (!src) return
    if (loadedSrcs.has(src)) {
      setReady(true)
      return
    }
    const node = imgRef.current
    if (node && node.complete && node.naturalWidth > 0) {
      loadedSrcs.add(src)
      setReady(true)
    }
  }, [src])

  const markReady = () => {
    if (src) loadedSrcs.add(src)
    setReady(true)
  }

  const openHref = (event) => {
    if (!href) return
    event.preventDefault()
    window.open(href, '_blank', 'noopener,noreferrer')
  }

  const photo = (
    <img
      ref={imgRef}
      className={`${styles.photo}${ready ? ` ${styles.photoReady}` : ''}`}
      src={src}
      alt={alt}
      loading="eager"
      decoding="async"
      draggable={false}
      onDragStart={(event) => event.preventDefault()}
      onLoad={markReady}
    />
  )

  if (href) {
    return (
      <article className={styles.tile}>
        <button
          type="button"
          className={styles.link}
          aria-label={alt || 'Відкрити посилання банера'}
          onClick={openHref}
          onDragStart={(event) => event.preventDefault()}
        >
          {photo}
        </button>
      </article>
    )
  }

  return <article className={styles.tile}>{photo}</article>
}
